import { computePlaces } from '@/engine';
import { PlaceBadge } from '@/components/design';
import type { Match, Participant, Tournament } from '@/data/types';

interface Props {
  tournament: Tournament;
  matches: Match[];
  participants: Participant[];
}

export function ResultsTable({ tournament, matches, participants }: Props) {
  if (matches.length === 0) {
    return <p className="t-mute">Турнир ещё не начался.</p>;
  }

  const nameById = new Map(participants.map((p) => [p.id, p.displayName]));
  const participantIds = participants.map((p) => p.id);
  const rows = computePlaces(
    matches,
    participantIds,
    tournament.format,
    tournament.groups
  );

  return (
    <div className="card-d" style={{ overflow: 'hidden' }}>
      <table className="tbl">
        <thead>
          <tr>
            <th style={{ width: 80 }}>Место</th>
            <th>Участник</th>
            <th>Статус</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.participantId}>
              <td><PlaceBadge place={r.place} /></td>
              <td>{nameById.get(r.participantId) ?? r.participantId}</td>
              <td className="t-mute">{r.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
